const PaymentPartnerStatus = {
  WAITING_CUSTOMER_PAYMENT: 1,
  WAITING_RETURN_DEADLINE: 2,
  REFUNDED: 3,
  WAITING_TRANSFER_PARTNER: 4,
  CANCELED: 5,
  PAID_PARTNER: 6,
};

export default PaymentPartnerStatus;

export function mapLabel(status) {
  const mapped = {
    [PaymentPartnerStatus.WAITING_CUSTOMER_PAYMENT]: 'Aguardando Cliente',
    [PaymentPartnerStatus.WAITING_RETURN_DEADLINE]: 'Aguardando Prazo',
    [PaymentPartnerStatus.REFUNDED]: 'Reembolsado',
    [PaymentPartnerStatus.WAITING_TRANSFER_PARTNER]: 'Aguardando Transferência',
    [PaymentPartnerStatus.CANCELED]: 'Cancelado',
    [PaymentPartnerStatus.PAID_PARTNER]: 'Pago',
  };
  
  return mapped[status];
}
